import { USER_STATUS } from "Common/dictionaries/userStatus";
import createReducer from "Common/reducerUtils/createReducer";
import compact from "lodash/compact";
import find from "lodash/find";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import omit from "lodash/omit";
import { NAMESPACE } from "../constants";
import userFactory from "../utils/userFactory";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        self: undefined,
        list: undefined,
        userStatusDictionary: undefined
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_USERS_COMPLETED]: (state, { payload }) => {
        var _a;
        const list = keyBy(map(payload, userFactory), "Id");
        if (isEqual(state[NAMESPACE].list, list))
            return state;
        const self = ((_a = state[NAMESPACE].self) === null || _a === void 0 ? void 0 : _a.Id)
            ? find(payload, ["Id", state[NAMESPACE].self.Id])
            : state[NAMESPACE].self;
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                self,
                list
            }
        };
    },
    [actionTypes.GET_USER_STATUS_DICTIONARY_COMPLETED]: (state, { payload }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            userStatusDictionary: payload
        }
    }),
    [actionTypes.GET_USER_STATUS_DICTIONARY_REJECTED]: (state) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            userStatusDictionary: []
        }
    }),
    [actionTypes.BLOCK_USERS_COMPLETED](state, { meta }) {
        if (!state[NAMESPACE].list)
            return state;
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list: {
                    ...state[NAMESPACE].list,
                    ...keyBy(compact(map(meta.ids, id => get(state[NAMESPACE].list, id)
                        ? { ...get(state[NAMESPACE].list, id), Status: USER_STATUS.BLOCKED }
                        : undefined)), "Id")
                }
            }
        };
    },
    [actionTypes.UNBLOCK_USERS_COMPLETED](state, { meta }) {
        if (!state[NAMESPACE].list)
            return state;
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list: {
                    ...state[NAMESPACE].list,
                    ...keyBy(compact(map(meta.ids, id => get(state[NAMESPACE].list, id)
                        ? { ...get(state[NAMESPACE].list, id), Status: USER_STATUS.ACTIVE }
                        : undefined)), "Id")
                }
            }
        };
    },
    [actionTypes.REMOVE_USERS_COMPLETED](state, { meta }) {
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list: omit(state[NAMESPACE].list, meta.ids)
            }
        };
    },
    [actionTypes.GET_SELF_COMPLETED]: (state, { payload }) => ({
        ...state,
        [NAMESPACE]: {
            ...state[NAMESPACE],
            self: userFactory(payload)
        }
    }),
    [actionTypes.SAVE_USER_COMPLETED]: (state, { payload }) => {
        var _a;
        return state[NAMESPACE].list
            ? {
                ...state,
                [NAMESPACE]: {
                    ...state[NAMESPACE],
                    self: ((_a = state[NAMESPACE].self) === null || _a === void 0 ? void 0 : _a.Id) === payload.Id
                        ? userFactory(payload)
                        : state[NAMESPACE].self,
                    list: {
                        ...state[NAMESPACE].list,
                        [payload.Id]: userFactory(payload)
                    }
                }
            }
            : state;
    }
});
